/**
 * AB#21912 — how many drawers are open right now, shared by every Drawer
 * instance (a `<script setup>` top-level variable would be per instance).
 */
export const drawerStack = { open: 0 };
